<div class="Loading" *ngIf="showLoading==true">
    <div class="loader"></div>
    <!-- <img id="" src="assets/img/762.gif"   /> -->
    <label class="loaderlabel">Please wait while Processing....</label>
</div>








<form #insuredForm="ngForm">
    <div class="card" style="width:100%;" id="InsuredInfo">
        <ul class="nav nav-tabs listdata" role="tablist">
            <li role="presentation" class="active">
                <a href="#home" aria-controls="home" role="tab"
                    data-toggle="tab">{{'Policy Holder Details' | translate }}</a>
            </li>
        </ul>
        <div class="tab-content domesticinsuredtab">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="domesticinsuredinfo1">


                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'ID Number' | translate }}</label>
                            <input type="text" class="form-control" required id="txtIdNo" name="txtIdNo" required
                                placeholder="{{objProposal.Insured_IDNo}}" disabled="true" />

                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'DOB' | translate }}</label>
                            <input type="text" class="form-control" required id="txtDOB" name="txtDOB" required
                                placeholder="{{objProposal.Insured_DOB | date: 'yyyy/MM/dd'}}" disabled="true" />

                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Insured Name' | translate }}</label>
                            <input type="text" class="form-control" required id="txtInsuredName" name="txtInsuredName"
                                required placeholder="{{objProposal.Insured_Name}}" disabled="true" />
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Nationality' | translate }}</label>
                            <input type="text" class="form-control" required id="txtNationality" name="txtNationality"
                                required
                                placeholder="{{ Lng=='en'? objProposal.Insured_Nationality_EnDesc : objProposal.Insured_Nationality_ArDesc }}"
                                disabled="true" />

                        </div>
                    </div>

                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Mobile Number' | translate }}</label>
                            <input type="text" class="form-control" required id="txtTelephone" name="txtTelephone"
                                required placeholder="{{objProposal.Insured_MobileNo}}" disabled="true" />

                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'EmailID' | translate }}</label>
                            <input type="text" class="form-control" required id="txtEmail" name="txtEmail" required
                                placeholder="{{objProposal.Insured_EmailId}}" disabled="true" />

                        </div>


                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="lbltext">{{ 'Occupation'| translate}}</label>
                            <select class="form-control" name="txtProfession" id="txtProfession" selectRequired
                                #txtProfession="ngModel" [(ngModel)]="objProposal.Insured_Profession">
                                <option value="">--{{ 'Select Occupation' | translate }}-- </option>
                                <option *ngFor="let profObj of objProposal.profList" [value]="profObj.Professioncode">
                                    {{Lng=="en"?profObj.ProfessionDesc_Eng:profObj.ProfessionDesc_Ar}}</option>
                            </select>
                            <span
                                *ngIf="txtProfession.invalid && (txtProfession.dirty || isSubmitted || txtProfession.touched)"
                                class="text-danger valid">
                                <div *ngIf="txtProfession.errors?.selectRequired">
                                    {{ 'Profession is required'| translate}}
                                </div>
                            </span>

                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label
                                class="Domesticlbltext">{{ 'If not Saudi, Tax Reg No. of Home Country' | translate }}</label>
                            <input type="text" class="form-control" required id="txtTaxRegNo" name="txtTaxRegNo"
                                required [(ngModel)]="objProposal.TaxRegNo" #txtTaxRegNo="ngModel"
                                disabled="{{objProposal.Insured_Nationality==90}}" />
                            <span
                                *ngIf="objProposal.Insured_Nationality!=90 &&(txtTaxRegNo.invalid && (txtTaxRegNo.dirty || txtTaxRegNo.touched || isSubmitted))"
                                class="text-danger valid">
                                <div *ngIf="txtTaxRegNo.errors.required">
                                    {{'Tax RegNo is required'|translate }}
                                </div>
                            </span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>


    <div class="card" style="width:100%;" id="InsuredInfo">
        <ul class="nav nav-tabs listdata" role="tablist">
            <li role="presentation" class="active">
                <a href="#home" aria-controls="home" role="tab"
                    data-toggle="tab">{{'Resident Address' | translate }}</a>
            </li>
        </ul>
        <div class="tab-content domesticinsuredtab">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="domesticinsuredinfo1">

                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Building No' | translate }}</label>
                            <input type="text" class="form-control" required id="txtBuilding" name="txtBuilding"
                                required [(ngModel)]="objProposal.Insured_BuildingNo" #txtBuilding="ngModel"
                                disabled="{{objProposal.IsBuildingNoExists}}" />
                            <span
                                *ngIf="txtBuilding.invalid && (txtBuilding.dirty || txtBuilding.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtBuilding.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span>
                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Residence Unit No' | translate }}</label>
                            <input type="text" class="form-control" required id="txtUnitNo" name="txtUnitNo"
                                [(ngModel)]="objProposal.Insured_UnitNo" #txtUnitNo="ngModel" numbersOnly minlength="4"
                                maxlength="4" disabled="{{objProposal.IsUnitNoExists}}" />
                            <span *ngIf="txtUnitNo.invalid && (txtUnitNo.dirty || txtUnitNo.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtUnitNo.errors?.required">
                                    {{ 'Unit No is required' | translate}}</div>
                                <div *ngIf="txtUnitNo.errors?.minlength">
                                    {{ 'Unit No must be 4 digits' | translate}}</div>
                                <div *ngIf="txtUnitNo.errors?.maxlength">
                                    {{ 'Unit No must be 4 digits' | translate}}</div>
                            </span>
                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Street Name' | translate }}</label>
                            <input type="text" class="form-control" required id="txtStreet" name="txtStreet" required
                                [(ngModel)]="objProposal.Insured_Street" #txtStreet="ngModel" disabled="{{objProposal.IsStreetExists}}"/>
                            <span *ngIf="txtStreet.invalid && (txtStreet.dirty || txtStreet.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtStreet.errors.required">
                                    {{'Street is required'|translate }}
                                </div>
                            </span>
                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'District Name' | translate }}</label>
                            <input type="text" class="form-control" required id="txtDistrict" name="txtDistrict"
                                required [(ngModel)]="objProposal.Insured_District" #txtDistrict="ngModel" disabled="{{objProposal.IsDistrictExists}}"/>
                            <span
                                *ngIf="txtDistrict.invalid && (txtDistrict.dirty || txtDistrict.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtDistrict.errors.required">
                                    {{'District is required'|translate }}
                                </div>
                            </span>
                        </div>
                    </div>

                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'City' | translate }}</label>
                            <input type="text" class="form-control" id="txtCity" name="txtCity" required
                                placeholder="{{ Lng=='en'? objProposal.Insured_City_EnDesc : objProposal.Insured_City_ArDesc }}"
                                disabled="{{objProposal.IsCityExists}}" />
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="!objProposal.IsCityExists">
                            <label class="Domesticlbltext">{{ 'City' | translate}} </label>
                            <select class="form-control" id="txtCityList" name="txtCityList"
                                [(ngModel)]="objProposal.Insured_City" #txtCityList="ngModel"
                                (change)="cityChange(objProposal.Insured_City)">
                                <option value="">---{{ 'Select City' | translate}}--</option>
                                <option *ngFor="let cty of objProposal.CityMasterList" [value]="cty.CITYNAME">
                                    {{ Lng=="en"? cty.CITYNAMEEn:cty.CITYNAMEAr }}</option>
                            </select>

                        </div>


                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Post BoxNo' | translate }}</label>
                            <input type="text" class="form-control" required id="txtBoxNo" name="txtBoxNo" required
                                [(ngModel)]="objProposal.Insured_PostalCode" #txtBoxNo="ngModel" disabled="{{objProposal.IsPostalCodeExists}}"  minlength="5"  maxlength="6"/>
                            <span *ngIf="txtBoxNo.invalid && (txtBoxNo.dirty || txtBoxNo.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtBoxNo.errors.required">
                                    {{'Post BoxNo is required'|translate }}
                                </div>
                            </span>
                        </div>


                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Residence Zip Code' | translate }}</label>
                            <input type="text" class="form-control" required id="txtZipCode" name="txtZipCode" required
                                [(ngModel)]="objProposal.Insured_PostalCode" #txtZipCode="ngModel" disabled="{{objProposal.IsPostalCodeExists}}"/>
                            <span *ngIf="txtZipCode.invalid && (txtZipCode.dirty || txtZipCode.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtZipCode.errors.required">
                                    {{'Zip Code is required'|translate }}
                                </div>
                            </span>
                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Residence Additional No' | translate }}</label>
                            <input type="text" class="form-control" required id="txtAdditionalNo" name="txtAdditionalNo"
                                required [(ngModel)]="objProposal.Insured_AdditionalCode" #txtAdditionalNo="ngModel" disabled="{{objProposal.IsAdditionalCodeExists}}"/>
                            <span
                                *ngIf="txtAdditionalNo.invalid && (txtAdditionalNo.dirty || txtAdditionalNo.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtAdditionalNo.errors.required">
                                    {{'Additional No is required'|translate }}
                                </div>
                            </span>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- DOMESTIC HELPER DETAILS START -->
    <div class="card" style="width:100%;" id="InsuredInfo">
        <ul class="nav nav-tabs listdata" role="tablist">
            <li role="presentation" class="active">
                <a href="#home" aria-controls="home" role="tab"
                    data-toggle="tab">{{'Domestic Helper Details' | translate }}</a>
            </li>
        </ul>
        <div class="tab-content domesticinsuredtab">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="domesticinsuredinfo1">
                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Name' | translate }}</label>
                            <input type="text" class="form-control"  id="txtHelperName" name="txtHelperName"
                                 [(ngModel)]="objRiskDetails.Name" #txtHelperName="ngModel" />
                            <!-- <span
                                *ngIf="txtHelperName.invalid && (txtHelperName.dirty || txtHelperName.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperName.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span> -->
                        </div>
                  

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Nationality' | translate }}</label>
                            <select class="form-control" [(ngModel)]="objRiskDetails.Nationality" name="txtHelperNat"
                                 #txtHelperNat="ngModel">
                                <option value="">--{{ 'Select Nationality' | translate }}--</option>
                                <option *ngFor="let Nat of objProposal.NationalityMasterList"
                                    [value]="Nat.NationalityCode">
                                    {{ Lng=="en"? Nat.NationalityDescEn:Nat.NationalityDescAr}}</option>
                            </select>
                            <!-- <span *ngIf="txtHelperNat.invalid && (txtHelperNat.dirty || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperNat.errors.required">
                                    {{ 'Nationality is required'| translate}}
                                </div>
                            </span> -->

                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Iqama No' | translate }}</label>
                            <input type="text" class="form-control"  id="txtHelperIqama" name="txtHelperIqama"
                                 [(ngModel)]="objRiskDetails.IqamaNo" #txtHelperIqama="ngModel" minlength="10"
                                maxlength="10" numbersOnly pattern="^[2]\d{9}$"/>
                            <!-- <span
                                *ngIf="txtHelperIqama.invalid && (txtHelperIqama.dirty || txtHelperIqama.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperIqama.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                                <div *ngIf="txtHelperIqama.errors?.minlength">
                                    {{ 'Iqama No must be 10 digits' | translate}}
                                </div>
                                <div *ngIf="txtHelperIqama.errors?.maxlength">
                                    {{ 'Iqama No must be 10 digits' | translate}}
                                </div>
                            </span> -->
                            <span  class="text-danger valid">
                                <div *ngIf="txtHelperIqama.errors?.pattern">
                                    {{ 'Iqama No must start with 2 and contain 10 digits'| translate}}
                                </div>
                            </span>

                        </div>

                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Date of Birth' | translate }}</label>
                            <input type="text" class="form-control"  id="txtHelperDOB" name="txtHelperDOB"
                                 [(ngModel)]="objRiskDetails.DOB" #txtHelperDOB="ngModel" bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD'}" (blur)="ValidateDOB($event.target.value)" autocomplete="off" [maxDate]="maxAgeDate"/>
                            <!-- <span
                                *ngIf="txtHelperDOB.invalid && (txtHelperDOB.dirty || txtHelperDOB.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperDOB.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span> -->
                        </div>
                    </div>

                    <div class="DomesticField row">


                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Gender' | translate }}</label>

                            <select class="form-control"  name="txtGender" id="txtGender"
                                [(ngModel)]="objRiskDetails.Gender" #txtGender="ngModel">
                                <option value="">--{{'Select Gender'| translate }}--</option>
                                <option *ngFor="let gen of objProposal.GenderList" [value]="gen.gendercode">
                                    {{ Lng=="en"? gen.genderdesc_En : gen.GenderDesc_Ar }}</option>
                            </select>
                            <!-- <span *ngIf="txtGender.invalid && (txtGender.dirty || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtGender.errors.required">
                                    {{ 'Gender is required'| translate }}
                                </div>
                            </span> -->
                        </div>


                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Post BoxNo' | translate }}</label>
                            <input type="text" class="form-control"  id="txtHelperPostBoxNo"
                                name="txtHelperPostBoxNo"  [(ngModel)]="objRiskDetails.PoBoxNo"
                                #txtHelperPostBoxNo="ngModel"
                                minlength="5" maxlength="6" pattern="^[1-9]\d{4}$" numbersOnly autocomplete="off" />
                            <!-- <span
                                *ngIf="txtHelperPostBoxNo.invalid && (txtHelperPostBoxNo.dirty || txtHelperPostBoxNo.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperPostBoxNo.errors.required">
                                    {{'Post BoxNo is required'|translate }}
                                </div>
                                <div *ngIf="txtHelperPostBoxNo.errors?.pattern">
                                    {{ 'Post Box Number must not start with zero'| translate}}
                                </div>
                            </span> -->
                            <div *ngIf="txtHelperPostBoxNo.errors?.pattern">
                                {{ 'Post Box Number must be 5 and should not start with zero'| translate}}
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Passport No' | translate }}</label>
                            <input type="text" class="form-control"  id="txtHelperPassport"
                                name="txtHelperPassport"  [(ngModel)]="objRiskDetails.PassportNo"
                                #txtHelperPassport="ngModel" maxlength="15"/>
                            <!-- <span
                                *ngIf="txtHelperPassport.invalid && (txtHelperPassport.dirty || txtHelperPassport.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperPassport.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span> -->
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Visa Number' | translate }}</label>
                            <input type="text" class="form-control" required id="txtHelperVisa" name="txtHelperVisa"
                                required [(ngModel)]="objRiskDetails.VisaNo" #txtHelperVisa="ngModel"  maxlength="15"/>
                            <span
                                *ngIf="txtHelperVisa.invalid && (txtHelperVisa.dirty || txtHelperVisa.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtHelperVisa.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DOMESTIC HELPER DETAILS END -->

    <div class="card" style="width:100%;" id="InsuredInfo">
        <ul class="nav nav-tabs listdata" role="tablist">
            <li role="presentation" class="active">
                <a href="#home" aria-controls="home" role="tab"
                    data-toggle="tab">{{'Policy Period Information' | translate }}</a>
            </li>
        </ul>
        <div class="tab-content domesticinsuredtablast">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="domesticinsuredinfo1">
                    <div class="DomesticField row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Policy Effective Date' | translate }}</label>
                            <input type="text" class="form-control" required id="txtPolicyStartDate"
                                name="txtPolicyStartDate" required bsDatepicker
                                [(ngModel)]="objProposal.PolicyFromDate" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }"
                                #txtPolicyStartDate="ngModel" [minDate]="minDate" autocomplete="off"/>
                            <span
                                *ngIf="txtPolicyStartDate.invalid && (txtPolicyStartDate.dirty || txtPolicyStartDate.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtPolicyStartDate.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label class="Domesticlbltext">{{ 'Policy Expiry Date' | translate }}</label>
                            <input type="text" class="form-control" required id="txtPolicyEndDate"
                                name="txtPolicyEndDate" required bsDatepicker [(ngModel)]="objProposal.PolicyToDate"
                                #txtPolicyEndDate="ngModel" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }"
                                [minDate]="minDate" [maxDate]="maxDate" autocomplete="off"/>
                            <span
                                *ngIf="txtPolicyEndDate.invalid && (txtPolicyEndDate.dirty || txtPolicyEndDate.touched || isSubmitted)"
                                class="text-danger valid">
                                <div *ngIf="txtPolicyEndDate.errors.required">
                                    {{'Insured ID is required'|translate }}
                                </div>
                            </span>
                        </div>
                    </div>

                    <div class="DomesticField row">
                        <div class="btndomesticrow">
                            <button class="btn btn-primary" id="btnprev"
                                (click)="Prev()">{{'Prev' | translate}}</button>
                            <button class="btn btn-primary" id="btnnext"
                                (click)="Next(insuredForm)">{{'Next' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</form>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/DomesticHelperPortal/DomesticInsuredInfo/DomesticInsuredInfo.html